import React, { useCallback, useEffect } from "react";
import { Progress } from "../../../../nq-component";

const MetricsCard = React.memo(
  ({ status, count, icon, colorClass, bgColor, onClick, progress }) => {
    const handleMouseEnter = useCallback((e) => {
      e.currentTarget.style.transform = "translateY(-4px)";
      e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.08)";
    }, []);

    const handleMouseLeave = useCallback((e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)";
    }, []);

    return (
      <div
        className="card border-0 metrics-card bg-white"
        role="button"
        tabIndex={0}
        onClick={onClick}
        style={{
          cursor: "pointer",
          transition: "all 0.3s ease",
          borderRadius: "12px",
          minHeight: "140px",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="card-body p-4 d-flex flex-column justify-content-between h-100">
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div
              className={`p-2 rounded-2 d-flex align-items-center justify-content-center ${colorClass} bg-opacity-10`}
              style={{
                width: "44px",
                height: "44px",
                backgroundColor: bgColor,
              }}
            >
              <i className={`${icon} fs-5 ${colorClass}`}></i>
            </div>
            <i className="bi bi-arrow-up-right text-muted opacity-50"></i>
          </div>
          <div>
            <h2
              className="h1 fw-bold text-dark mb-2"
              style={{ fontSize: "2.5rem", lineHeight: "1" }}
            >
              {progress ? <Progress /> : count || 0}
            </h2>
            <p
              className="text-muted mb-0 fw-medium"
              style={{ fontSize: "0.9rem" }}
            >
              {status}
            </p>
          </div>
        </div>
      </div>
    );
  }
);

export default MetricsCard;
